import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

export const TableNestedWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "table-nested-wrapper",
})`
  overflow: auto;
  min-width: 100%;
  padding-top: 15px;
  padding-bottom: 10px;
  position: relative;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 0;
  }
`;
